export default "__VITE_ASSET__BL0Rpap4__"